import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useZxing } from "react-zxing";
import api from "../../../services/api";
import {
  Box,
  Stack,
  IconButton,
  Typography,
  Backdrop,
  CircularProgress,
  Alert,
  AlertTitle,
  Collapse,
} from "@mui/material";
import { Close } from "@mui/icons-material";
import "./style.css";
import { useAuth } from "../../../hooks/auth";

export const QrScan = () => {
  const { cookies } = useAuth();
  const {data, attendant} = cookies;
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [openError, setOpenError] = useState(false);
  const [openSuccess, setOpenSuccess] = useState(false);
  const [openInfo, setOpenInfo] = useState(false);
  const [openWarning, setOpenWarning] = useState(false);
  const [count, setCount] = useState(0);
  // const handleToggle = (text) => {
  //   if(text !== ""){
  //     setOpen(!open);
  //     console('works')
  //   }
  //   console.log('nada')
  // };

  const [qrresult, setQRResult] = useState("");
  const [error, setError] = useState("");
  const { ref } = useZxing({
    onResult(result) {
      setQRResult(result.getText());
    },
    onError(error) {
      setError(error);
    },
  });

  const handleVerification = async (qrresult) => {
    try {
      const response = await api.post(
        "/key/decrypt",
        { code: qrresult, role: data.role, attendant_name: attendant.fullname, meal_type: attendant.mealtype, food_name: attendant.foodname},
        {
          headers: {
            Authorization: `Bearer ${data.token}`,
        }
      });
      console.log(response.data);
      if (response) {
        setOpen(false);
        // if (response.data.msg === "success") {
        //   setOpenSuccess(true);
        // } else {
        //   setOpenError(true);
        // }
      }
      // Do something with response data, like update state
    } catch (error) {
      console.error(error.request);
      setOpen(false);
      // setOpenInfo(true);
    }
  };

  useEffect(() => {
    if (qrresult !== "") {
      setOpen(true);
      console.log("works");

      handleVerification(qrresult);
    }
  }, [qrresult]);

  useEffect(() => {
    if (error !== "") {
      setCount(count + 1);
      if (count === 1){
        setOpenWarning(true);
      }
    }
  }, [count]);

  const handleClose = () => {
    navigate("/scanned-transactions");
  };

  return (
    <Box
      sx={{
        backgroundColor: "#000",
        backgroundImage: "FORTUNE_PRECIOUS.jpg",
        height: "100vh",
      }}
    >
      <IconButton sx={{ color: "white", padding: "5px" }} onClick={handleClose}>
        <Close fontSize="large" />
      </IconButton>
      <Collapse in={openSuccess}>
        <Alert
          sx={{ width: "86%", margin: "auto" }}
          variant="filled"
          severity="success"
          onClose={() => {
            navigate("/scanned-transactions");
          }}
        >
          <AlertTitle>Success</AlertTitle>
          Meal Ticket <strong>verified</strong> and <strong>recorded!</strong>
        </Alert>
      </Collapse>
      <Collapse in={openError}>
        <Alert
          sx={{ width: "86%", margin: "auto" }}
          variant="filled"
          severity="error"
          onClose={() => {
            setOpenError(false);
            setCount(0);
          }}
        >
          <AlertTitle>Error</AlertTitle>
          Meal Ticket is <strong>invalid!</strong>
        </Alert>
      </Collapse>
      <Collapse in={openInfo}>
        <Alert
          sx={{ width: "86%", margin: "auto" }}
          variant="filled"
          severity="info"
          onClose={() => {
            setOpenInfo(false);
            setCount(0);
          }}
        >
          <AlertTitle>Info</AlertTitle>
          Check your <strong>internet</strong> connection!
        </Alert>
      </Collapse>
      <Collapse in={openWarning}>
        <Alert
          sx={{ width: "86%", margin: "auto" }}
          variant="filled"
          severity="warning"
          onClose={() => {
            setOpenWarning(false);
          }}
        >
          <AlertTitle>Scan Ticket</AlertTitle>
          <strong>Please scan a meal ticket!</strong>
        </Alert>
      </Collapse>
      <Stack
        sx={{
          position: "absolute",
          top: "130px",
          alignItems: "center",
          justifyContent: "center",
          width: "100vw",
        }}
        color="white"
        spacing={2}
      >
        <video className="video-adjust" ref={ref} />
        <Box>
          <span>
            {qrresult ? (
              <Typography variant="h6" color="white" textAlign="center">
                MEAL TICKET SCANNED!
              </Typography>
            ) : (
              <Typography variant="h6" color="white" textAlign="center">
                SCAN MEAL TICKET
              </Typography>
            )}
          </span>
        </Box>
      </Stack>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={open}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </Box>
  );
};
